/* =====================================================================
   KOULUTUSPÄIVÄ-KALENTERI  →  assets/training-calendar.js

   - Renderöi kuukausikalenterin [data-training-calendar]-elementtiin.
   - Vain arkipäivät (ma–pe) valittavissa, ei menneisyyteen (tänään ok).
   - Valinta → piilo-input [data-training-date-input] (ISO YYYY-MM-DD).
   - Lukitsee lomakkeen lähetysnapin (data-add-button) kunnes päivä valittu.
   - Ei kirjastoja. Toimii usealla kalenterilla samalla sivulla.
   ===================================================================== */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // Paikallinen ISO (EI toISOString – se on UTC ja voi hypätä päivän yli).
  function isoLocal(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }

  // Suomalainen / englantilainen näyttömuoto valitulle päivälle.
  function displayDate(root, y, m, d) {
    var lang = root.getAttribute('data-lang') || 'fi';
    var months = (root.getAttribute('data-months') || '').split(',');
    var days = (root.getAttribute('data-days') || '').split(','); // ma..su
    var jsDow = new Date(y, m, d).getDay();      // 0=su..6=la
    var idx = (jsDow + 6) % 7;                    // 0=ma..6=su
    var dayName = days[idx] || '';
    var monthName = months[m] || '';
    if (lang === 'en') {
      // "Fri, 12 September 2025"
      return dayName + ', ' + d + ' ' + monthName + ' ' + y;
    }
    // "pe 12.9.2025"
    return dayName + ' ' + d + '.' + (m + 1) + '.' + y;
  }

  function build(root) {
    if (root.__trcalInit) return;
    root.__trcalInit = true;

    var monthLabel = root.querySelector('[data-trcal-monthlabel]');
    var grid = root.querySelector('[data-trcal-grid]');
    var weekdaysEl = root.querySelector('[data-trcal-weekdays]');
    var statusEl = root.querySelector('[data-trcal-status]');
    var prevBtn = root.querySelector('[data-trcal-prev]');
    var nextBtn = root.querySelector('[data-trcal-next]');
    var input = root.querySelector('[data-training-date-input]');
    if (!grid || !monthLabel || !input) return;

    var months = (root.getAttribute('data-months') || '').split(',');
    var dayHeads = (root.getAttribute('data-days') || '').split(','); // ma..su
    var i18nSelected = root.getAttribute('data-i18n-selected') || 'Valittu';
    var lockText = root.getAttribute('data-i18n-locktext') || 'Valitse koulutuspäivä';
    var noneText = statusEl ? statusEl.textContent : '';

    // Ostoslomakkeen nappi (sama lomake jossa input on).
    var form = root.closest('form');
    var addBtn = form ? form.querySelector('[data-add-button]') : null;
    var addLabelEl = addBtn ? addBtn.querySelector('.buy__add-label') : null;
    var originalLabel = addLabelEl ? addLabelEl.textContent : '';

    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var todayY = today.getFullYear(), todayM = today.getMonth(), todayD = today.getDate();

    var viewY = todayY, viewM = todayM;    // näkyvä kuukausi
    var selY = null, selM = null, selD = null;

    // Viikonpäiväotsikot (ma..su)
    if (weekdaysEl && !weekdaysEl.childElementCount) {
      for (var w = 0; w < 7; w++) {
        var wd = document.createElement('span');
        wd.className = 'trcal__weekday';
        wd.textContent = dayHeads[w] || '';
        weekdaysEl.appendChild(wd);
      }
    }

    function lockAdd() {
      if (!addBtn) return;
      addBtn.disabled = true;
      addBtn.classList.add('is-trcal-locked');
      if (addLabelEl) addLabelEl.textContent = lockText;
    }
    function unlockAdd() {
      if (!addBtn) return;
      addBtn.disabled = false;
      addBtn.classList.remove('is-trcal-locked');
      if (addLabelEl) addLabelEl.textContent = originalLabel;
    }

    function isPast(y, m, d) {
      var dt = new Date(y, m, d); dt.setHours(0, 0, 0, 0);
      return dt.getTime() < today.getTime();
    }
    function isWeekend(y, m, d) {
      var dow = new Date(y, m, d).getDay();
      return dow === 0 || dow === 6;
    }
    // Onko näkyvä kuukausi kokonaan menneisyydessä → prev-nappi lukkoon.
    function atOrBeforeToday(y, m) {
      return (y < todayY) || (y === todayY && m <= todayM);
    }

    function render() {
      monthLabel.textContent = (months[viewM] || '') + ' ' + viewY;
      prevBtn.disabled = atOrBeforeToday(viewY, viewM);

      grid.innerHTML = '';
      var firstDow = new Date(viewY, viewM, 1).getDay(); // 0=su..6=la
      var lead = (firstDow + 6) % 7;                       // ma-alkuinen
      var daysInMonth = new Date(viewY, viewM + 1, 0).getDate();

      for (var i = 0; i < lead; i++) {
        var blank = document.createElement('span');
        blank.className = 'trcal__day trcal__day--empty';
        grid.appendChild(blank);
      }

      for (var d = 1; d <= daysInMonth; d++) {
        var cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'trcal__day';
        cell.textContent = d;

        var past = isPast(viewY, viewM, d);
        var weekend = isWeekend(viewY, viewM, d);
        var selectable = !past && !weekend;

        if (viewY === todayY && viewM === todayM && d === todayD) {
          cell.classList.add('trcal__day--today');
        }

        if (selectable) {
          cell.classList.add('trcal__day--selectable');
          cell.setAttribute('data-trcal-day', d);
        } else {
          cell.classList.add('trcal__day--disabled');
          cell.disabled = true;
        }

        if (selY === viewY && selM === viewM && selD === d) {
          cell.classList.add('trcal__day--selected');
          cell.setAttribute('aria-pressed', 'true');
        }

        grid.appendChild(cell);
      }
    }

    function select(d) {
      selY = viewY; selM = viewM; selD = d;
      input.value = isoLocal(viewY, viewM, d);
      if (statusEl) {
        statusEl.textContent = i18nSelected + ': ' + displayDate(root, viewY, viewM, d);
        statusEl.classList.add('trcal__status--set');
      }
      unlockAdd();
      render();
    }

    // --- tapahtumat (delegaatio rootin sisällä) ---
    root.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-trcal-prev]');
      var next = e.target.closest('[data-trcal-next]');
      var day = e.target.closest('[data-trcal-day]');

      if (prev && !prev.disabled) {
        viewM--; if (viewM < 0) { viewM = 11; viewY--; }
        render(); return;
      }
      if (next) {
        viewM++; if (viewM > 11) { viewM = 0; viewY++; }
        render(); return;
      }
      if (day) {
        select(parseInt(day.getAttribute('data-trcal-day'), 10));
      }
    });

    // Aloitustila: lukitse nappi, tyhjä input.
    input.value = '';
    lockAdd();
    render();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-training-calendar]');
    for (var i = 0; i < roots.length; i++) build(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Jos sektio uudelleenrenderöityy (Theme Editor / section rendering).
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();